var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "container", staticClass: "vc-popup-conatiner" }, [
    _c("svg", { attrs: { display: "none" } }, [
      _c(
        "filter",
        { attrs: { id: "vc-effect-turbulence" } },
        [
          _c("feTurbulence", {
            attrs: {
              type: "fractalNoise",
              baseFrequency: "0 8.001",
              numOctaves: "2",
              "data-filterId": "3"
            }
          }),
          _vm._v(" "),
          _c("feDisplacementMap", {
            attrs: {
              xChannelSelector: "R",
              yChannelSelector: "G",
              in: "SourceGraphic",
              scale: "20"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-027d98cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-027d98cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup-base/popup-conatiner.vue
// module id = 52
// module chunks = 1